import { Title } from '@components/atoms/Title';
import { Button, Footer } from '@components/atoms';
import { useUserContext } from '@context/UserContext';
import { useNavigate } from 'react-router-dom';
import { SuccessCard } from '@components/organism';
import { UserData } from '@constants/useUserData';

export function UserSuccess() {
    const { selectedUser: user, setSelectedUser } = useUserContext();
     const { getDocumentInfo} = UserData(user);
    const navigate = useNavigate();

    if (!user) return <div className="p-4">Usuário não encontrado.</div>;

    const info = [
        { label: `${user.user_fields?.cnpj_regex ? 'Razão social' : 'Nome'}`, value: user.name || user.user_fields?._pessoa_juridica__razao_social },
        getDocumentInfo(),
        { label: 'Número', value: user.phone ?? '—' },
        { label: 'E-mail', value: user.email ?? '—' },
    ];

    return (
        <div className="bg-[#e8f5ee] h-160 flex flex-col">
            <div className="p-4">
                <Title title="• Editar conta" />
            </div>

            <SuccessCard title='Conta editada com sucesso' info={info} />

            <Footer>
                <Button isStretched onClick={() => {
                    setSelectedUser(null);
                    navigate('/');
                }}>
                    Voltar
                </Button>
            </Footer>
        </div>
    );
}
